"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "createOverflowManager", {
    enumerable: true,
    get: ()=>_overflowManager.createOverflowManager
});
const _overflowManager = require("./overflowManager");
 //# sourceMappingURL=index.js.map

//# sourceMappingURL=index.js.map